import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/")({
  staticData: {
    title: "home.title",
  },
  loader: () => redirect({ to: "/admin/home" }),
});
